import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.bookFlight
)

export const selectFlight = createSelector(
    baseSelector,
    (state) => state.flight
)

export const selectFlightLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectLoadedFlightId = createSelector(
    baseSelector,
    (state) => state.loadedFlightId
)

export const selectFlightSeatMap = createSelector(
    baseSelector,
    (state) => state.seatMap
)

export const selectFlightPriceMap = createSelector(
    baseSelector,
    (state) => state.priceMap
)

export const selectFlightSegmentsMap = createSelector(
    baseSelector,
    (state) => state.segmentsMap
)

export const selectFlightFareFamilies = createSelector(
    baseSelector,
    (state) => state.fareFamiliesFlights
)

export const selectAllFareFamilyFlights = createSelector(
    baseSelector,
    (state) => [state.flight, ...state.fareFamiliesFlights]
)

export const selectSelectedFareFamilyFlightId = createSelector(
    baseSelector,
    (state) => state.selectedFareFamilyFlightId ?? state.flight.id
)

export const selectSelectedFlight = createSelector(
    baseSelector,
    (state) => {
        if (!state.selectedFareFamilyFlightId) return state.flight
        return state.fareFamiliesFlights.find((f) => f.id === state.selectedFareFamilyFlightId) ?? state.flight
    }
)